import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { CommonReduxState } from '@dealstack/frontend/shared/globalConfig';
import { getUserOrganizationId } from '@dealstack/frontend/shared/dataExchange/services/user.service';

/**
 * Resolves the id of the organization the current user belongs to.
 * Keyed on the current user id, so it refetches whenever the logged-in user changes.
 */
const useUserOrganizationId = () => {
	const userId = useSelector((state: CommonReduxState) => state.user.data?.id);

	const { data: organizationId, ...rest } = useQuery({
		queryKey: ['userOrganizationId', userId],
		queryFn: getUserOrganizationId,
		enabled: !!userId,
	});

	return { organizationId: organizationId ?? undefined, ...rest };
};

export { useUserOrganizationId };
